import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.ts'), 'store/index.ts')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/breadcrumbs.ts'), 'breadcrumbs.ts')
  resolveStoreModules(require('../store/buttonAgent.js'), 'buttonAgent.js')
  resolveStoreModules(require('../store/cardsLk.ts'), 'cardsLk.ts')
  resolveStoreModules(require('../store/cookies.ts'), 'cookies.ts')
  resolveStoreModules(require('../store/coreData.ts'), 'coreData.ts')
  resolveStoreModules(require('../store/geoData.ts'), 'geoData.ts')
  resolveStoreModules(require('../store/headerNavLinks.ts'), 'headerNavLinks.ts')
  resolveStoreModules(require('../store/intendet.ts'), 'intendet.ts')
  resolveStoreModules(require('../store/lang.ts'), 'lang.ts')
  resolveStoreModules(require('../store/mediaQuery.ts'), 'mediaQuery.ts')
  resolveStoreModules(require('../store/metricsBot.ts'), 'metricsBot.ts')
  resolveStoreModules(require('../store/modal.ts'), 'modal.ts')
  resolveStoreModules(require('../store/navigation.ts'), 'navigation.ts')
  resolveStoreModules(require('../store/news.ts'), 'news.ts')
  resolveStoreModules(require('../store/notifications.ts'), 'notifications.ts')
  resolveStoreModules(require('../store/oldPage.ts'), 'oldPage.ts')
  resolveStoreModules(require('../store/pagesData.ts'), 'pagesData.ts')
  resolveStoreModules(require('../store/popupBuyOnline.ts'), 'popupBuyOnline.ts')
  resolveStoreModules(require('../store/popupCityList.ts'), 'popupCityList.ts')
  resolveStoreModules(require('../store/popupReviewDetail.ts'), 'popupReviewDetail.ts')
  resolveStoreModules(require('../store/popupSearchBot.ts'), 'popupSearchBot.ts')
  resolveStoreModules(require('../store/prolongationContext.ts'), 'prolongationContext.ts')
  resolveStoreModules(require('../store/prolongationRendering.ts'), 'prolongationRendering.ts')
  resolveStoreModules(require('../store/region.ts'), 'region.ts')
  resolveStoreModules(require('../store/registry.ts'), 'registry.ts')
  resolveStoreModules(require('../store/router.ts'), 'router.ts')
  resolveStoreModules(require('../store/scrollBarWidth.ts'), 'scrollBarWidth.ts')
  resolveStoreModules(require('../store/sections.ts'), 'sections.ts')
  resolveStoreModules(require('../store/settings.ts'), 'settings.ts')
  resolveStoreModules(require('../store/toast.ts'), 'toast.ts')
  resolveStoreModules(require('../store/userAgent.ts'), 'userAgent.ts')
  resolveStoreModules(require('../store/userIp.ts'), 'userIp.ts')
  resolveStoreModules(require('../store/ym.ts'), 'ym.ts')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
